
import React from 'react'
import PropTypes from 'prop-types';
import {TextField} from '@material-ui/core';

const DateEditor = (props) => {
  const {value, onValueChange} = props;
  const handleChangeValue = ({target: {value}}) => onValueChange(value);

  return (
    <TextField
      value={value ? value : ''}
      onChange={handleChangeValue}
      type="date"
      fullWidth
      variant="standard"
      InputLabelProps={{
        shrink: true,
        style: {
          fontSize: 20,
        },
      }}
      InputProps={{style: {fontSize: 13, color: 'grey'}}}
    />
  );
};

DateEditor.propTypes = {
  value: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
};

DateEditor.defaultProps = {
  value: null,
};

export default DateEditor;
